import { PageApi } from 'api/PageApi';
import { Page } from 'model/Page';

import { PageItemMapper } from './PageItemMapper';

export class PageMapper {
  private pageItemMapper: PageItemMapper;

  constructor(pageItemMapper: PageItemMapper) {
    this.pageItemMapper = pageItemMapper;
  }

  deserialize(entry: PageApi.Entry): Page {
    return new Page({
      project: entry.project,
      id: entry.id,
      position: entry.position,
      items: (entry.items || [])
        .map((item) => this.pageItemMapper.deserialize(item))
        .sort((itemA, itemB) => itemA.getPosition() - itemB.getPosition()),
    });
  }
}
